import Vue from 'vue';
import VueStatic from 'vue-static';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import PortalVue from 'portal-vue';
import VueScrollTo from 'vue-scrollto';
import * as Sentry from '@sentry/vue';
import store from './store';
import router from './router';
import App from './app/app.vue';
import './shared-components';
import 'vue-good-table/dist/vue-good-table.css';
import addMapScript from './utils/addMapScript';

import './validate-settings';

Sentry.init({
  Vue,
  dsn: 'https://3ca45542e017488fb59d106081f88ed3@sentry.dostaevsky.ru/14',
  integrations: [Sentry.browserTracingIntegration({router}), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,

  tracePropagationTargets: [/^https:\/\/weblogist\.(staging\.)?dostaevsky\.ru\//],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

Vue.use(VueStatic);

moment.locale('ru');

Vue.use(VueMoment, { moment });

Vue.use(PortalVue);

Vue.use(VueScrollTo);

Vue.filter('phoneFormat', (value) => {
  if (value) {
    const valueString = value.toString();
    const match = valueString.match(/^\+?(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
      return `+${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}`;
    }
    return value;
  }
  return value;
});

export const bus = new Vue();

Vue.prototype.$bus = bus;

new Vue({
  store,
  router,
  render: (h) => h(App),
  created() {
    addMapScript((apiIndex) => {
      /**
       * сохранять обязательно для последующих ошибок
       */
      this.$store.commit('mapLoading/SET_LOADING', false, { root: true });
      this.$store.commit('mapLoading/SET_API_INDEX', apiIndex, { root: true });
    });
  },
}).$mount('#app');
